import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["onPointerDown", "onPointerUp"],
    _excluded2 = ["onFocus", "onKeyDown"],
    _excluded3 = ["onKeyDown", "onFocus", "onBlur"],
    _excluded4 = ["item"],
    _excluded5 = ["onClick"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useCallback, useContext } from 'react';
import { SelectContext } from '../context';
import { showFreeform } from '../utils';
import { defaultFreeformItem } from '../utils/defaults';
import { merge } from 'lodash';
export function useSelect() {
  var context = useContext(SelectContext);
  var searchable = context.searchable,
      freeform = context.freeform,
      menuOpenOnFocus = context.menuOpenOnFocus,
      items = context.items,
      isOpen = context.isOpen,
      inputValue = context.inputValue,
      highlightedIndex = context.highlightedIndex,
      selectedItem = context.selectedItem,
      selectedItems = context.selectedItems,
      openMenu = context.openMenu,
      closeMenu = context.closeMenu,
      itemToString = context.itemToString,
      selectItemExternal = context.selectItemExternal,
      downshiftGetComboboxProps = context.getComboboxProps,
      downshiftGetInputProps = context.getInputProps,
      downshiftGetMenuProps = context.getMenuProps,
      downshiftGetItemProps = context.getItemProps,
      downshiftGetToggleButtonProps = context.getToggleButtonProps;
  var selectOnFocus = useCallback(function () {
    if (menuOpenOnFocus.current) {
      if (!isOpen) {
        openMenu();
      }
    }

    menuOpenOnFocus.current = true;
  }, [isOpen, menuOpenOnFocus, openMenu]);
  var selectOnKeyDown = useCallback(function (e) {
    // Reset this flag every time we press any key otherwise
    // downshift thinks we always want to prevent it's default
    // after doing it once :/
    e.preventDownshiftDefault = false; // Prevent the default when pressing enter so that the
    // text input doesn't run the onBlur function when
    // we don't want it to

    if (e.key === 'Enter') {
      e.preventDefault();

      if (!isOpen) {
        openMenu();
      }

      if (freeform) {
        var handleAction = freeform.handleAction; // Don't select the item that is currently highlighted
        // and also do the freeform action when using the shift
        // modifier key when focused on the input

        if ((e.shiftKey || // We haven't highlighted any of the items
        highlightedIndex === -1 || // We have highlighted the fixture (always the last item)
        highlightedIndex === items.length) && showFreeform({
          freeform: freeform,
          inputValue: inputValue,
          items: items,
          selectedItem: selectedItem,
          selectedItems: selectedItems,
          itemToString: itemToString
        })) {
          e.preventDownshiftDefault = true;
          handleAction({
            inputValue: inputValue,
            selectItem: selectItemExternal
          });
        }
      }
    }
  }, [freeform, items, isOpen, inputValue, highlightedIndex, selectedItem, selectedItems, openMenu, itemToString, selectItemExternal]);
  var getComboboxProps = useCallback(function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var options = arguments.length > 1 ? arguments[1] : undefined;

    var _onPointerDown = _ref.onPointerDown,
        onPointerUp = _ref.onPointerUp,
        props = _objectWithoutProperties(_ref, _excluded);

    return downshiftGetComboboxProps(_objectSpread(_objectSpread({}, props), {}, {
      onPointerDown: function onPointerDown(e) {
        if (e.target !== window.document.activeElement) {
          // Stop the current element from being blurred
          // (either the toggle button or input) only if
          // we haven't clicked the currently focused element
          e.preventDefault();
        }

        _onPointerDown === null || _onPointerDown === void 0 ? void 0 : _onPointerDown(e);
      }
    }), merge({}, {
      suppressRefError: true
    }, options));
  }, [downshiftGetComboboxProps]);
  var getInputProps = useCallback(function () {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var options = arguments.length > 1 ? arguments[1] : undefined;

    var _onFocus = _ref2.onFocus,
        _onKeyDown = _ref2.onKeyDown,
        props = _objectWithoutProperties(_ref2, _excluded2);

    return downshiftGetInputProps(_objectSpread(_objectSpread({}, props), {}, {
      onFocus: function onFocus(e) {
        selectOnFocus();
        _onFocus === null || _onFocus === void 0 ? void 0 : _onFocus(e);
      },
      onKeyDown: function onKeyDown(e) {
        selectOnKeyDown(e);
        _onKeyDown === null || _onKeyDown === void 0 ? void 0 : _onKeyDown(e);
      }
    }), merge({}, {
      suppressRefError: true
    }, options));
  }, [downshiftGetInputProps, selectOnFocus, selectOnKeyDown]);
  var getMenuProps = useCallback(function (props, options) {
    return downshiftGetMenuProps(props, merge({}, {
      suppressRefError: true
    }, options));
  }, [downshiftGetMenuProps]);
  var getItemProps = useCallback(function (props) {
    return downshiftGetItemProps(props);
  }, [downshiftGetItemProps]);
  var getToggleButtonProps = useCallback(function () {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var propOnKeyDown = _ref3.onKeyDown,
        _onFocus2 = _ref3.onFocus,
        _onBlur = _ref3.onBlur,
        props = _objectWithoutProperties(_ref3, _excluded3);

    // For some reason the toggle button doesn't have keydown
    // handlers in the new downshift-hooks so add it here
    var _getInputProps = getInputProps({
      onKeyDown: propOnKeyDown
    }),
        onKeyDown = _getInputProps.onKeyDown;

    return downshiftGetToggleButtonProps(_objectSpread(_objectSpread({}, props), {}, {
      tabIndex: props.disabled ? undefined : 0,
      onKeyDown: onKeyDown,
      onFocus: function onFocus(e) {
        selectOnFocus();
        _onFocus2 === null || _onFocus2 === void 0 ? void 0 : _onFocus2(e);
      },
      onBlur: function onBlur(e) {
        // We only want to close the menu on blur when the input
        // is not searchable because we focus the menu text input
        // on searchable selects which blurs the toggle button
        if (!searchable && isOpen) {
          closeMenu();
        }

        _onBlur === null || _onBlur === void 0 ? void 0 : _onBlur(e);
      }
    }));
  }, [searchable, isOpen, closeMenu, getInputProps, downshiftGetToggleButtonProps, selectOnFocus]);
  var getHeadingProps = useCallback(function (_ref4) {
    var item = _ref4.item,
        props = _objectWithoutProperties(_ref4, _excluded4);

    return getItemProps(_objectSpread(_objectSpread({}, props), {}, {
      // We need to be able to send the heading items to downshift
      // so that we can have the headings as part of the virtualisation.
      // We're disabling them always so the user never interacts
      // with them, so for all outside interaction with downshift we only ever
      // use `NormalisedItem` so we only want to pass that type to downshift
      item: item,
      disabled: true
    }));
  }, [getItemProps]);
  var getFixtureProps = useCallback(function (_ref5) {
    var _onClick = _ref5.onClick,
        props = _objectWithoutProperties(_ref5, _excluded5);

    return getItemProps(_objectSpread(_objectSpread({}, props), {}, {
      // This allows us to have the freeform fixture behave just
      // like a normal menu item for accessibility but it won't
      // be selectable because we can stop the selection by
      // checking this default freeform item in the state reducer
      item: defaultFreeformItem,
      onClick: function onClick(e) {
        if (freeform) {
          var handleAction = freeform.handleAction;
          handleAction({
            inputValue: inputValue,
            selectItem: selectItemExternal
          });
        }

        _onClick === null || _onClick === void 0 ? void 0 : _onClick(e);
      }
    }));
  }, [freeform, inputValue, getItemProps, selectItemExternal]);
  return _objectSpread(_objectSpread({}, context), {}, {
    getComboboxProps: getComboboxProps,
    getInputProps: getInputProps,
    getMenuProps: getMenuProps,
    getItemProps: getItemProps,
    getToggleButtonProps: getToggleButtonProps,
    getHeadingProps: getHeadingProps,
    getFixtureProps: getFixtureProps
  });
}